import { getHostname } from '../location/location'

export const getCustomDomain = () => {
  const host = getHostname()

  if (host === 'localhost') {
    return null
  }

  const appDomain = import.meta.env.VITE_APP_DOMAIN

  if (appDomain && host?.includes(appDomain)) {
    return null
  }

  return host
}

export const getPortalBasePath = slug => (getCustomDomain() ? '' : `/${slug}`)
